import { z } from 'zod';
import { baseComponentSchema, buttonSchema } from '../component-base.schemas';

// CTA background image schema
export const ctaBackgroundImageSchema = z
  .object({
    enabled: z.boolean().default(false),
    url: z.string().url('Invalid image URL').optional(),
    cloudfrontUrl: z.string().url('Invalid CloudFront URL').optional(),
    alt: z.string().max(200, 'Alt text too long').optional(),
    position: z
      .enum([
        'center',
        'top',
        'bottom',
        'left',
        'right',
        'top-left',
        'top-right',
        'bottom-left',
        'bottom-right',
      ])
      .default('center')
      .optional(),
    size: z.enum(['cover', 'contain', 'auto', '100%']).default('cover').optional(),
    repeat: z.enum(['no-repeat', 'repeat', 'repeat-x', 'repeat-y']).default('no-repeat').optional(),
    parallax: z.boolean().default(false).optional(),
    overlay: z
      .object({
        enabled: z.boolean().default(false),
        color: z
          .string()
          .regex(/^#[0-9A-Fa-f]{6}$/)
          .default('#000000')
          .optional(),
        opacity: z.number().min(0).max(1).default(0.5).optional(),
      })
      .optional(),
  })
  .optional();

export const ctaDataSchema = z.object({
  title: z.string().min(1, 'CTA title is required'),
  subtitle: z.string().optional(),
  buttons: z.array(buttonSchema).default([]),
  alignment: z.enum(['left', 'center', 'right']).default('center'),
  backgroundImage: ctaBackgroundImageSchema,
});

export const ctaComponentSchema = baseComponentSchema.extend({
  type: z.literal('cta'),
  data: ctaDataSchema,
});

// Type exports
export type CtaData = z.infer<typeof ctaDataSchema>;
export type CtaComponent = z.infer<typeof ctaComponentSchema>;
